// libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FacebookIcon,
  FacebookShareButton,
  PinterestIcon,
  PinterestShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';
import { CopyToClipboard } from 'react-copy-to-clipboard';

// Styles
import './styles.scss';

class SocialShare extends Component {
  static propTypes = {
    shareUrl: PropTypes.string.isRequired,
    shareImgUrl: PropTypes.string.isRequired,
    shareDescription: PropTypes.string.isRequired,
  };
  static contextTypes = {
    t: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      copied: false,
    };
  }

  componentDidUpdate() {
    const { copied } = this.state;
    if (copied) {
      this.hideCopiedTooltip = setTimeout(() => {
        this.setState(() => ({ copied: false }));
      }, 2500);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.hideCopiedTooltip);
  }

  render() {
    const { shareUrl, shareImgUrl, shareDescription } = this.props;
    const { copied } = this.state;
    const { t } = this.context;

    return (
      <div className="sharer__socials" >
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={35} round={false} />
        </FacebookShareButton>
        <TwitterShareButton url={shareUrl}>
          <TwitterIcon size={35} round={false} />
        </TwitterShareButton>
        { shareUrl &&
        <PinterestShareButton
          url={shareUrl}
          media={shareImgUrl}
          description={shareDescription}
        >
          <PinterestIcon size={35} round={false} />
        </PinterestShareButton>
        }
        <div className="sharer__copy">
          <CopyToClipboard
            text={shareUrl}
            onCopy={() => this.setState({ copied: true })}
          >
            <button
              className="sharer__copy__button"
            />
          </CopyToClipboard>
          {copied &&
            <span className="sharer__copy__tooltip">{t('pages.copiedUrl')}</span>
          }
        </div>
      </div>
    );
  }
}

export default SocialShare;




// WEBPACK FOOTER //
// ./src/app/components/tools/share/SocialShare.js